"use strict";

import React from "react";
import { Route } from 'react-router-dom';

function Routes(route) {
    return (
        <Route
            exact={route.exact}
            path={route.path}
            render={props => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} {...route.props} routes={route.routes} />
            )}
        />
    );
}

export default Routes;